import { css } from "styled-components";

const $weightMedium = 500;
// const $blackBis = "hsl(216, 49%, 10%)";
// const $black = `${$blackBis}`;
// const $blackTer = "hsl(207, 59%, 15%)";
// const $greyDarker = "hsl(211, 22%, 38%)";
const $greyDark = "hsl(213, 14%, 51%)";
// const $grey = `${$greyDark}`;
// const $greyLight = "hsl(212, 14%, 63%)";
const $greyLighter = "hsl(214, 26%, 85%)";
const $whiteTer = "hsl(212, 23%, 93%)";
// const $whiteBis = "hsl(240, 18%, 98%)";
const $white = "hsl(0, 0%, 100%)";
const $orange = "hsl(34, 97%, 48%)";
// const $yellow = "hsl(48, 97%, 57%)";
const $green = "hsl(105, 67%, 43%)";
// const $turquoise = "hsl(215, 67%, 50%)";
const $cyan = "#059DF5";
// const $blue = "hsl(215, 67%, 50%)";
const $red = "hsl(9, 91%, 61%)";
// const $cyanDark = "hsl(205, 100%, 69%)";
// const $greenDark = "hsl(91, 53%, 57%)";
// const $yellowDark = "hsl(51, 100%, 66%)";
// const $redDark = "hsl(1, 99%, 64%)";
// const $orangeDark = "hsl(33, 100%, 63%)";
// const $cyanLight = "hsl(203, 100%, 88%)";
// const $greenLight = "hsl(107, 49%, 65%)";
// const $yellowLight = "hsl(52, 100%, 73%)";
// const $redLight = "hsl(17, 90%, 76%)";
// const $orangeLight = "hsl(35, 97%, 73%)";
const $cyanLighter = "hsl(204, 100%, 94%)";
const $greenLighter = "hsl(113, 75%, 92%)";
// const $yellowLighter = "hsl(52, 96%, 90%)";
const $redLighter = "hsl(11, 100%, 96%)";
const $orangeLighter = "hsl(34, 99%, 90%)";
// const $primary = `${$cyan}`;
const $tablet = "769px";
// const $text = `${$greyDarker}`;
// const $textLight = `${$greyDark}`;
// const $navbarBoxShadowSize = "0 1px 0 0";
// const $navbarBoxShadowColor = `${$whiteTer}`;
// const $navbarHeight = "4.25rem";
// const $navbarBreakpoint = "480px";
// const $switchBackgroundActive = `${$green}`;
// const $boxPadding = "2rem";
const $boxShadow = `0 1px 4px 0 ${$whiteTer}, 0 0 0 1px ${$whiteTer}`;
const $radiusSmall = "2px";
const $radius = "3px";
const $radiusLarge = "6px";
// const $checkboxBorder = `1px solid ${$greyLighter}`;
// const $labelWeight = `${$weightMedium}`;
// const $labelColor = `${$greyDarker}`;

export const globalMixin = css`
  .navbar.navbar {
    box-shadow: $navbar-box-shadow-size $navbar-box-shadow-color;
  }

  .is-divider.is-divider {
    margin: 1rem 0 2rem 0;
    border-top: 1px solid ${$greyLighter};
  }

  button {
    &.is-primary,
    &.is-link,
    &.is-info,
    &.is-success,
    &.is-warning,
    &.is-danger {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.04);
      font-weight: 500;
    }
    &.is-transparent {
      background: none;
      border: 0;
      padding: 0;
      &:focus {
        box-shadow: none !important;
      }
    }
  }
  img {
    &.is-rounded {
      object-fit: cover;
      border-radius: 50%;
      object-position: top;
    }
  }

  .has-border-radius-small {
    border-radius: ${$radiusSmall};
  }

  .has-border-radius {
    border-radius: ${$radius};
  }

  .has-border-radius-large {
    border-radius: ${$radiusLarge};
  }

  .steps.steps {
    &.is-small {
      font-size: 1rem;
      .step-item {
        .step-marker {
          width: 1rem;
          height: 1rem;
          top: 5px;
          left: calc(50% - 0.5rem);
        }
      }
    }
  }

  .modal-card.modal-card {
    margin: 0 !important;
    padding: 0 20px;
  }

  .modal-card-body {
    padding: 0 30px;
  }

  .modal-card-head {
    border-bottom: none;
    background: ${$white};
  }

  .has-shadow-normal {
    box-shadow: ${$boxShadow};
  }

  .legends {
    display: flex;
    flex-flow: wrap;
    padding: 0;
    margin: 0;
    list-style: none;
    -webkit-print-color-adjust: exact !important;

    li {
      margin-right: 1rem;
      display: flex;
      align-items: center;

      .symbol {
        width: 16px;
        height: 16px;
        min-width: 16px;
        min-height: 16px;
        margin-right: 0.5rem;
        border-radius: 4px;
      }
    }
  }

  .tag {
    font-weight: ${$weightMedium};
    background: ${$whiteTer} !important;
    color: ${$greyDark} !important;

    &.is-light {
      background: ${$white}-ter !important;
      color: ${$greyDark} !important;
    }
    &.is-link {
      background: ${$cyanLighter} !important;
      color: ${$cyan} !important;
    }
    &.is-success {
      background: ${$greenLighter} !important;
      color: ${$green} !important;
    }
    &.is-danger {
      background: ${$redLighter} !important;
      color: ${$red} !important;
    }
    &.is-warning {
      background: ${$orangeLighter} !important;
      color: ${$orange} !important;
    }
  }

  .dropdown-trigger {
    .button {
      text-align: left;
      display: flex;
      justify-content: space-between;
    }
  }

  .text-gray {
    color: ${$greyDark};
  }

  .has-text-weight-medium {
    font-weight: 500;
  }

  @media print {
    .hidden-print {
      display: none !important;
    }
    .box {
      box-shadow: none !important;
      padding: 0rem !important;
      border: 0 !important;
    }
    .print-full-width {
      width: 100% !important;
    }
  }

  .pagebreak {
    page-break-after: always;
  }

  @media screen and (min-width: 1280px) {
    .container {
      max-width: 980px !important;
      width: 980px !important;
    }
  }

  @media screen and (max-width: 1279px) {
    .container {
      padding: 20px; /* until we use Alexandria  and remove container css class */
    }
  }

  @media screen and (max-width: ${$tablet}) {
    .box {
      padding: 1rem !important;
    }

    .slider-item .box,
    .slider-item .card-content {
      padding: 1rem 0 !important;
    }
  }

  .ad-preview img {
    width: auto !important;
    height: 320px !important;
    margin: 0 auto !important;
  }

  .slider-pagination {
    display: none !important;
  }

  @media screen and (max-width: ${$tablet}) {
    .listings-property .image {
      margin-bottom: 1rem;
    }
    .listings-property .media-left {
      margin-right: 0;
    }
  }

  .carousel .slide {
    background: transparent !important;
    text-align: inherit !important;
  }

  .popover {
    .popover-content {
      padding: 8px 16px;

      &::before {
        border-width: 0.36rem;
        margin-left: -0.38rem;
      }
    }
  }

  .modal-card.modal-wide {
    @media screen and (min-width: ${$tablet}) {
      width: 80%;
    }
  }
`;
